import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { exportCompleteProject, exportQuickProject } from '../../utilities/projectExporter';
import { getLanguageTranslations } from '../../utilities/translations';
import './Navbar.css';


const Navbar = () => {
  const [language, setLanguage] = useState(() => localStorage.getItem('app_language') || 'ar');

  // Always sync language state with localStorage on every render
  useEffect(() => {
    const lang = localStorage.getItem('app_language') || 'ar';
    if (lang !== language) setLanguage(lang);
  });

  const t = getLanguageTranslations(language);
  const location = useLocation();

  // استمع لتغييرات اللغة من localStoragec
  useEffect(() => {
    const handleStorageChange = () => {
      const newLang = localStorage.getItem('app_language') || 'ar';
      setLanguage(newLang);
    };

    window.addEventListener('storage', handleStorageChange);
    
    // تحقق من التغييرات كل 500 ميلي ثانية (للتغييرات في نفس التبويب)
    const interval = setInterval(() => {
      const currentLang = localStorage.getItem('app_language') || 'ar';
      if (currentLang !== language) {
        setLanguage(currentLang);
      }
    }, 500);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, [language]);
  const exportCurrentProject = () => {
    try {
      const lastId = localStorage.getItem('cad_last_project_id');
      if (!lastId) {
        alert(t.noActiveProjectToExport || 'لا يوجد مشروع نشط لتصديره.');
        return;
      }
      
      // الحصول على اسم المشروع
      const projectsList = JSON.parse(localStorage.getItem('cad_projects_list') || '[]');
      const currentProject = projectsList.find(p => p.id === lastId);
      const projectName = currentProject?.name || (t.project || 'مشروع');
      
      // تصدير المشروع الكامل
      const result = exportCompleteProject(lastId, projectName);
      
      if (result.success) {
        alert(`${result.message}\n${t.fileName || 'اسم الملف'}: ${result.fileName}`);
      } else {
        alert(result.message);
      }
    } catch (e) {
      console.error('فشل تصدير المشروع:', e);
      alert(t.exportProjectFailed || 'فشل تصدير المشروع');
    }
  };

  const exportQuickCurrentProject = () => {
    try {
      const lastId = localStorage.getItem('cad_last_project_id');
      if (!lastId) {
        alert(t.noActiveProjectToExport || 'لا يوجد مشروع نشط لتصديره.');
        return;
      }
      
      const projectsList = JSON.parse(localStorage.getItem('cad_projects_list') || '[]');
      const currentProject = projectsList.find(p => p.id === lastId);
      const projectName = currentProject?.name || (t.project || 'مشروع');
      
      const result = exportQuickProject(lastId, projectName);
      
      if (result.success) {
        alert(result.message);
      } else {
        alert(result.message);
      }
    } catch (e) {
      console.error('فشل التصدير السريع:', e);
      alert(t.quickExportFailed || 'فشل التصدير السريع');
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-brand">
          <Link to="/">{t.appTitle || 'تطبيق التخطيط المعماري'}</Link>
        </div>
        <ul className="navbar-menu">
          <li className="navbar-item">
            <Link
              to="/projects"
              className={`navbar-link${location.pathname === '/projects' || location.pathname === '/' ? ' active' : ''}`}
            >
              📁 {t.projectManagement || 'إدارة المشاريع'}
            </Link>
          </li>
          <li className="navbar-item">
            <Link
              to="/sketch"
              className={`navbar-link${location.pathname === '/sketch' || location.pathname === '/floor' ? ' active' : ''}`}
            >
              ✏️ {t.drawingArea || 'منطقة الرسم'}
            </Link>
          </li>
          <li className="navbar-item">
            <a
              href="#"
              className="navbar-link"
              onClick={e => { e.preventDefault(); exportCurrentProject(); }}
              title={t.exportCompleteDesc || 'تصدير المشروع الحالي (كامل)'}
            >
              💾 {t.exportComplete || 'تصدير كامل'}
            </a>
          </li>
          <li className="navbar-item">
            <a
              href="#"
              className="navbar-link"
              onClick={e => { e.preventDefault(); exportQuickCurrentProject(); }}
              title={t.exportQuickDesc || 'تصدير سريع للمشروع الحالي'}
            >
              ⚡ {t.exportQuick || 'تصدير سريع'}
            </a>
          </li>
          <li className="navbar-item">
            <select
              className="navbar-lang-combobox"
              value={language}
              onChange={e => {
                setLanguage(e.target.value);
                localStorage.setItem('app_language', e.target.value);
              }}
              title={t.language || 'اللغة'}
              style={{
                backgroundColor: '#28a745',
                color: '#fff',
                fontWeight: 'bold',
                borderRadius: '8px',
                padding: '8px 16px',
                border: 'none',
                fontSize: '1rem',
                marginLeft: '8px',
                cursor: 'pointer'
              }}
            >
              <option value="ar">🇸🇦 العربية</option>
              <option value="en">🇬🇧 English</option>
            </select>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
